import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import Isvg from 'react-inlinesvg'
import classNames from 'classnames'

import { localize } from 'helpers/translator'
import { MainButton } from 'components/button'

import styles from './google_slides_unauthorized_create_view.scss'

import GSImage from 'assets/views/gs_paywall/gs_paywall.svg'

class GoogleSlidesUnauthorizedCreate extends PureComponent {

	render() {
		return (
			<main styleName={classNames({
				wrapper: true,
				'wrapper--small': this.props.shouldRenderSmallerView,
			})}>
				<h2 styleName='title'>{localize('gs_paywallModal_title')}</h2>
				<Isvg
					src={GSImage}
					cacheGetRequests={true}
					styleName='image'
				/>
				<ul styleName='options-list'>
					<li styleName='options-list-item'>
						<span styleName='options-list-item-text'>
							{localize('gs_paywallModal_list_1_part1')}
							<span styleName='options-list-item-text--strong'>{localize('gs_paywallModal_list_1_part2')}</span>
							{localize('gs_paywallModal_list_1_part3')}
						</span>
					</li>
					<li styleName='options-list-item'>
						<span styleName='options-list-item-text'>
							{localize('gs_paywallModal_list_2_part1')}
							<span styleName='options-list-item-text--strong'>{localize('gs_paywallModal_list_2_part2')}</span>
							{localize('gs_paywallModal_list_2_part3')}
						</span>
					</li>
				</ul>
				<footer styleName='footer'>
					<p styleName='footer-upgrade-text'>{localize('gs_paywallModal_upgradeText')}</p>
					<p styleName='footer-upgrade-code'>{this.props.upgradeCode}</p>
					<div styleName='footer-button'>
						<MainButton
							focus={true}
							tabIndex={101}
							onClick={this.props.handleUpgrade}
						>
							{localize('gs_paywallModal_button')}
						</MainButton>
					</div>
					<p styleName='footer-disclaimer'>{localize('gs_paywallModal_disclaimer')}</p>
				</footer>
			</main>
		)
	}
}

GoogleSlidesUnauthorizedCreate.defaultProps = {
	shouldRenderSmallerView: false,
}

GoogleSlidesUnauthorizedCreate.propTypes = {
	handleUpgrade: PropTypes.func.isRequired,
	upgradeCode: PropTypes.string.isRequired,
	shouldRenderSmallerView: PropTypes.bool,
}

export default CSSModules(GoogleSlidesUnauthorizedCreate, styles, {allowMultiple: true})
